import '../../constants/icons/index.mjs';
import '../../types/index.mjs';
import { Language } from '../../types/constants.mjs';
import { StoreId } from '../../types/generated.mjs';
import _externalAssets_DhQQZUho__default from "../../assets/waveMlo.svg";
import _externalAssets_Dxp1T5JX__default from "../../assets/ltu5ghz.svg";
import _externalAssets_LBBa85wh__default from "../../assets/airMax5ghz.svg";
import _externalAssets_BOy2ygw4__default from "../../assets/airMax24ghz.svg";
import _externalAssets_CpudPnX7__default from "../../assets/airFiberPtP.svg";
import _externalAssets_DnZUGHoA__default from "../../assets/antennasWireless.svg";
import _externalAssets_C6aD4TiH__default from "../../assets/xgsPon.svg";
import _externalAssets_IeLPrGjf__default from "../../assets/gpon.svg";
import _externalAssets_3p3EcO_W__default from "../../assets/uispRouter.svg";
import _externalAssets_Dx2SMtBZ__default from "../../assets/uispAdvancedRouter.svg";
import _externalAssets_DlooEO87__default from "../../assets/efgStacked.svg";
import _externalAssets_oUcKf$lg__default from "../../assets/dreamMachineProMax.svg";
import _externalAssets_BRM6VTe5__default from "../../assets/ultra-cloud-gateway.svg";
import _externalAssets_DA6H_Emm__default from "../../assets/express.svg";
import _externalAssets_DYuD7OP___default from "../../assets/dreamRouter.svg";
import _externalAssets_DcaTZUSz__default from "../../assets/dreamWall.svg";
import _externalAssets_CI9fPBZA__default from "../../assets/wifiIntegrated.svg";
import _externalAssets_DB4Gaq6j__default from "../../assets/swWan.svg";
import _externalAssets_Cx9aj6Rn__default from "../../assets/swEnterprise.svg";
import _externalAssets_Bf_54zbe__default from "../../assets/swProXg.svg";
import _externalAssets_B0X_t3Jf__default from "../../assets/swProMax.svg";
import _externalAssets_DGZronZW__default from "../../assets/swPro.svg";
import _externalAssets_BbFiyURO__default from "../../assets/swProMax.svg";
import _externalAssets_Dn54mv2t__default from "../../assets/swCompact.svg";
import _externalAssets_lZbdiTvk__default from "../../assets/wifiEnterprise.svg";
import _externalAssets_BpAHE3Kz__default from "../../assets/flagship.svg";
import _externalAssets_NhqTXzWJ__default from "../../assets/inWall.svg";
import _externalAssets_DoUzeQKl__default from "../../assets/flexibleOutdoor.svg";
import _externalAssets_C69oNIT5__default from "../../assets/stadium.svg";
import _externalAssets_Cd1Cv1NY__default from "../../assets/buildingBridge.svg";
import _externalAssets_a4tESIiF__default from "../../assets/deviceBridge.svg";
import _externalAssets_CqhVoPUD__default from "../../assets/bridging.svg";
import _externalAssets_D2$2b9Kg__default from "../../assets/domeTurret.svg";
import _externalAssets_CJUPKRFm__default from "../../assets/bullet.svg";
import _externalAssets_B8O2FjLu__default from "../../assets/flexAndInstant.svg";
import _externalAssets_Q7IS2DVB__default from "../../assets/interiorDesign.svg";
import _externalAssets_BhTWNUe$__default from "../../assets/ptz.svg";
import _externalAssets_h17pgRRZ__default from "../../assets/special-devices.svg";
import _externalAssets_T7rpQKbk__default from "../../assets/nvr.svg";
import _externalAssets_ENcKgMBe__default from "../../assets/controlHubs.svg";
import _externalAssets_DtLdUP7O__default from "../../assets/readers.svg";
import _externalAssets_CJvMBI3i__default from "../../assets/intercomViewers.svg";
import _externalAssets_BFhHoK$c__default from "../../assets/locksAccessories.svg";
import _externalAssets_BspeJKN4__default from "../../assets/touchPass.svg";
import _externalAssets_DPMNLIio__default from "../../assets/phones.svg";
import _externalAssets_GYevzP4Z__default from "../../assets/mobileRouting.svg";
import _externalAssets_ChdEjBXM__default from "../../assets/evCharging.svg";
import _externalAssets_2M8ibhOQ__default from "../../assets/poeDisplayTop.svg";
import _externalAssets_D7iijHbw__default from "../../assets/powerAmp.svg";
import _externalAssets_CSNKwvWT__default from "../../assets/unas.svg";
import _externalAssets_D37k8sgh__default from "../../assets/powerTech.svg";
import _externalAssets_6$HKdBjs__default from "../../assets/cabling.svg";
import _externalAssets_BFVOBxjM__default from "../../assets/rack2.svg";
import _externalAssets_DRzhtlf4__default from "../../assets/storage.svg";
import _externalAssets_BUjasMxx__default from "../../assets/internetSolutions.svg";
import _externalAssets_BM8zMoz6__default from "../../assets/specificConsoles.svg";
"use strict";
var SiteId = /* @__PURE__ */(SiteId2 => {
  SiteId2["Ui"] = "ui";
  SiteId2["Uisp"] = "uisp";
  SiteId2["Store"] = "store";
  SiteId2["Amplifi"] = "amplifi";
  SiteId2["Generic"] = "generic";
  SiteId2["TechSpecs"] = "techSpecs";
  SiteId2["ExpertsUi"] = "expertsUi";
  SiteId2["ExpertsUisp"] = "expertsUisp";
  SiteId2["Uwc"] = "uwc";
  SiteId2["Blog"] = "blog";
  SiteId2["CaseStudies"] = "caseStudies";
  SiteId2["Installations"] = "installations";
  SiteId2["Creators"] = "creators";
  return SiteId2;
})(SiteId || {});
const DEFAULT_LANGUAGE = Language.En;
const LONG_LANGUAGES = [Language.De];
const DEFAULT_STORE_ID = StoreId.Us;
const GENERIC_SITE_IDS = ["generic" /* Generic */, "techSpecs" /* TechSpecs */, "uwc" /* Uwc */, "blog" /* Blog */, "caseStudies" /* CaseStudies */];
const NavigationItemId = {
  CloudGateways: "cloud-gateways",
  WiFi: "wifi",
  Switching: "switching",
  CameraSecurity: "camera-security",
  DoorAccess: "door-access",
  Integrations: "integrations",
  Accessories: "accessories",
  UnifiIdentity: "unifi-identity",
  SixtyGhzWireless: "60ghz-wireless",
  Wireless: "wireless",
  Fiber: "fiber",
  Wired: "wired",
  UispAccessoryTech: "uisp-accessory-tech",
  UispSoftware: "uisp-software",
  LargeDeploymentAssistance: "large-deployment-assistance"
};
const NAVIGATION_MAPPING = {
  primary: {
    label: "UniFi",
    // fallbackUrl: [SiteId.Ui, "/"],
    url: ["ui" /* Ui */, "/"],
    items: [{
      id: NavigationItemId.CloudGateways,
      label: "Cloud Gateways",
      key: "cloud-gateways",
      url: ["ui" /* Ui */, "/cloud-gateways"],
      items: [{
        id: "enterprise-scale",
        label: "Enterprise Scale",
        icon: {
          src: _externalAssets_DlooEO87__default,
          width: 114,
          height: 25
        },
        url: ["ui" /* Ui */, "/cloud-gateways/enterprise-scale"]
      }, {
        id: "large-scale",
        label: "Large Scale",
        icon: {
          src: _externalAssets_oUcKf$lg__default,
          width: 113,
          height: 14
        },
        url: ["ui" /* Ui */, "/cloud-gateways/large-scale"]
      }, {
        id: "gateways-compact",
        label: "Compact",
        icon: {
          src: _externalAssets_BRM6VTe5__default,
          width: 55.86,
          height: 14
        },
        mobileIcon: {
          src: _externalAssets_BRM6VTe5__default,
          width: 30,
          height: 7,
          useRawHeight: true
        },
        isNew: true,
        url: ["ui" /* Ui */, "/cloud-gateways/compact"]
      }, {
        id: "wifi-integrated",
        label: "WiFi Integrated",
        icon: {
          src: _externalAssets_CI9fPBZA__default,
          width: 38,
          height: 38
        },
        isNew: true,
        items: [{
          id: "express",
          label: "Express 7",
          icon: {
            src: _externalAssets_DA6H_Emm__default,
            width: 36,
            height: 14
          },
          isNew: true,
          url: ["ui" /* Ui */, "/cloud-gateways/wifi-integrated/express"]
        }, {
          id: "dream-router",
          label: "Dream Router 7",
          icon: {
            src: _externalAssets_DYuD7OP___default,
            width: 22,
            height: 38
          },
          isNew: true,
          url: ["ui" /* Ui */, "/cloud-gateways/wifi-integrated/dream-router"]
        }, {
          id: "dream-wall",
          label: "Dream Wall",
          icon: {
            src: _externalAssets_DcaTZUSz__default,
            width: 27,
            height: 36
          },
          url: ["ui" /* Ui */, "/cloud-gateways/wifi-integrated/dream-wall"]
        }]
      }]
    }, {
      id: NavigationItemId.Switching,
      label: "Switching",
      url: ["ui" /* Ui */, "/switching"],
      items: [{
        id: "switching-wan",
        label: "WAN",
        icon: {
          src: _externalAssets_DB4Gaq6j__default,
          width: 113,
          height: 24
        },
        isNew: true,
        url: ["ui" /* Ui */, "/switching/wan"]
      }, {
        id: "switching-enterprise",
        label: "Enterprise Campus",
        icon: {
          src: _externalAssets_Cx9aj6Rn__default,
          width: 114,
          height: 36
        },
        isNew: true,
        url: ["ui" /* Ui */, "/switching/enterprise-campus"]
      }, {
        id: "switching-professional-xg",
        label: "Professional XG",
        icon: {
          src: _externalAssets_Bf_54zbe__default,
          width: 113,
          height: 36
        },
        isNew: true,
        url: ["ui" /* Ui */, "/switching/professional-xg"]
      }, {
        id: "switching-pro-max",
        label: "Professional Max",
        icon: {
          src: _externalAssets_B0X_t3Jf__default,
          width: 113,
          height: 36
        },
        url: ["ui" /* Ui */, "/switching/professional-max"]
      }, {
        id: "switching-pro",
        label: "Professional",
        icon: {
          src: _externalAssets_DGZronZW__default,
          width: 115,
          height: 36
        },
        url: ["ui" /* Ui */, "/switching/professional"]
      }, {
        id: "switching-standard",
        label: "Standard",
        icon: {
          src: _externalAssets_BbFiyURO__default,
          width: 115,
          height: 36
        },
        url: ["ui" /* Ui */, "/switching/standard"]
      }, {
        id: "switching-utility",
        label: "Utility",
        icon: {
          src: _externalAssets_Dn54mv2t__default,
          width: 73,
          height: 35
        },
        url: ["ui" /* Ui */, "/switching/utility"],
        isNew: true
      }]
    }, {
      id: NavigationItemId.WiFi,
      label: "WiFi",
      url: ["ui" /* Ui */, "/wifi"],
      items: [{
        id: "enterprise",
        label: "Enterprise",
        icon: {
          src: _externalAssets_lZbdiTvk__default,
          width: 83,
          height: 38
        },
        url: ["ui" /* Ui */, "/wifi/enterprise"]
      }, {
        id: "flagship",
        label: "Flagship",
        icon: {
          src: _externalAssets_BpAHE3Kz__default,
          width: 38,
          height: 38
        },
        isNew: true,
        url: ["ui" /* Ui */, "/wifi/flagship"]
      }, {
        id: "wall",
        label: "Wall",
        icon: {
          src: _externalAssets_NhqTXzWJ__default,
          width: 24,
          height: 38
        },
        url: ["ui" /* Ui */, "/wifi/wall"]
      }, {
        id: "outdoor",
        label: "Outdoor",
        icon: {
          src: _externalAssets_DoUzeQKl__default,
          width: 34,
          height: 38
        },
        isNew: true,
        url: ["ui" /* Ui */, "/wifi/outdoor"]
      }, {
        id: "mega-capacity",
        label: "Mega Capacity",
        icon: {
          src: _externalAssets_C69oNIT5__default,
          width: 69,
          height: 38
        },
        url: ["ui" /* Ui */, "/wifi/mega-capacity"]
      }, {
        id: "bridging",
        label: "Bridging",
        isNew: true,
        icon: {
          src: _externalAssets_CqhVoPUD__default,
          width: 82,
          height: 38
        },
        items: [{
          id: "bridging-building-bridge",
          label: "Building Bridge",
          icon: {
            src: _externalAssets_Cd1Cv1NY__default,
            width: 75,
            height: 38
          },
          url: ["ui" /* Ui */, "/wifi/bridging/building-bridge"]
        }, {
          id: "bridging-device-bridge",
          label: "Device Bridge",
          isNew: true,
          icon: {
            src: _externalAssets_a4tESIiF__default,
            width: 44,
            height: 38
          },
          url: ["ui" /* Ui */, "/wifi/bridging/device-bridge"]
        }]
      }]
    }, {
      id: NavigationItemId.CameraSecurity,
      label: "Camera Security",
      url: ["ui" /* Ui */, "/camera-security"],
      items: [{
        id: "dome",
        label: "Dome & Turret",
        icon: {
          src: _externalAssets_D2$2b9Kg__default,
          width: 72,
          height: 38
        },
        url: ["ui" /* Ui */, "/camera-security/dome-turret"]
      }, {
        id: "bullet",
        label: "Bullet",
        icon: {
          src: _externalAssets_CJUPKRFm__default,
          width: 49,
          height: 26
        },
        url: ["ui" /* Ui */, "/camera-security/bullet"]
      }, {
        id: "compact",
        label: "Compact",
        icon: {
          src: _externalAssets_B8O2FjLu__default,
          width: 31,
          height: 39
        },
        url: ["ui" /* Ui */, "/camera-security/compact"]
      }, {
        id: "theta",
        label: "Interior Design",
        icon: {
          src: _externalAssets_Q7IS2DVB__default,
          width: 62,
          height: 29
        },
        url: ["ui" /* Ui */, "/camera-security/interior-design"]
      }, {
        id: "ptz",
        label: "PTZ",
        icon: {
          src: _externalAssets_BhTWNUe$__default,
          width: 27,
          height: 38
        },
        isNew: true,
        url: ["ui" /* Ui */, "/camera-security/ptz"]
      }, {
        id: "special",
        label: "Special Devices",
        icon: {
          src: _externalAssets_h17pgRRZ__default,
          width: 32,
          height: 38
        },
        isNew: true,
        url: ["ui" /* Ui */, "/camera-security/special-devices"]
      }, {
        id: "nvr",
        label: "Video Recorders",
        icon: {
          src: _externalAssets_T7rpQKbk__default,
          width: 114,
          height: 36
        },
        url: ["ui" /* Ui */, "/camera-security/video-recorders"]
      }]
    }, {
      id: NavigationItemId.DoorAccess,
      label: "Door Access",
      url: ["ui" /* Ui */, "/door-access"],
      items: [{
        id: "door-access-control-hubs",
        label: "Control Hubs",
        url: ["ui" /* Ui */, "/door-access/control-hubs"],
        icon: {
          src: _externalAssets_ENcKgMBe__default,
          width: 53,
          height: 38
        },
        isNew: true
      }, {
        id: "door-access-readers",
        label: "Readers",
        url: ["ui" /* Ui */, "/door-access/readers"],
        icon: {
          src: _externalAssets_DtLdUP7O__default,
          width: 21.9,
          height: 38
        },
        isNew: true
      }, {
        id: "door-access-intercoms-viewers",
        label: "Intercoms",
        url: ["ui" /* Ui */, "/door-access/intercoms"],
        icon: {
          src: _externalAssets_CJvMBI3i__default,
          width: 25.5,
          height: 38
        }
      }, {
        id: "door-access-accessories",
        label: "Locks & Accessories",
        url: ["ui" /* Ui */, "/door-access/locks-accessories"],
        icon: {
          src: _externalAssets_BFhHoK$c__default,
          width: 32,
          height: 38
        }
      }, {
        id: "door-access-touch-pass",
        label: "Touch Pass",
        url: ["ui" /* Ui */, "/door-access/touch-pass"],
        icon: {
          src: _externalAssets_BspeJKN4__default,
          width: 25.3,
          height: 38
        },
        isNew: true
      }]
    }, {
      id: NavigationItemId.Integrations,
      label: "Integrations",
      items: [{
        id: "phone",
        label: "Managed VoIP",
        icon: {
          src: _externalAssets_DPMNLIio__default,
          width: 56,
          height: 38
        },
        isNew: true,
        url: ["ui" /* Ui */, "/integrations/managed-voip"]
      }, {
        id: "mobile-routing",
        label: "Mobile Routing",
        icon: {
          src: _externalAssets_GYevzP4Z__default,
          width: 34,
          height: 38
        },
        url: ["ui" /* Ui */, "/integrations/mobile-routing"]
      }, {
        id: "ev-charging",
        label: "EV Charging",
        icon: {
          src: _externalAssets_ChdEjBXM__default,
          width: 55,
          height: 38
        },
        url: ["ui" /* Ui */, "/integrations/ev-charging"]
      }, {
        id: "digital-signage",
        label: "Digital Signage",
        icon: {
          src: _externalAssets_2M8ibhOQ__default,
          width: 38,
          height: 38
        },
        url: ["ui" /* Ui */, "/integrations/digital-signage"]
      }, {
        id: "premium-audio",
        label: "Premium Audio",
        icon: {
          src: _externalAssets_D7iijHbw__default,
          width: 49,
          height: 17
        },
        url: ["ui" /* Ui */, "/integrations/premium-audio"]
      }, {
        id: "network-storage",
        label: "Network Storage",
        icon: {
          src: _externalAssets_CSNKwvWT__default,
          width: 114,
          height: 24
        },
        url: ["ui" /* Ui */, "/integrations/network-storage"]
      }]
    }, {
      id: NavigationItemId.Accessories,
      label: "Accessory Tech",
      url: ["ui" /* Ui */, "/accessory-tech"],
      items: [{
        id: "power-systems",
        label: "Power Tech",
        icon: {
          src: _externalAssets_D37k8sgh__default,
          width: 32,
          height: 36
        },
        url: ["ui" /* Ui */, "/accessory-tech", void 0, "power-tech"]
      }, {
        id: "cables",
        label: "Cables",
        icon: {
          src: _externalAssets_6$HKdBjs__default,
          width: 26,
          height: 29
        },
        url: ["ui" /* Ui */, "/accessory-tech", void 0, "cables"]
      }, {
        id: "installations",
        label: "Installations",
        icon: {
          src: _externalAssets_BFVOBxjM__default,
          width: 41,
          height: 38
        },
        url: ["ui" /* Ui */, "/accessory-tech", void 0, "installations"]
      }, {
        id: "storage",
        label: "Storage",
        icon: {
          src: _externalAssets_DRzhtlf4__default,
          width: 24,
          height: 33
        },
        url: ["ui" /* Ui */, "/accessory-tech", void 0, "storage"]
      }, {
        id: "internet-solutions",
        label: "Internet Solutions",
        icon: {
          src: _externalAssets_BUjasMxx__default,
          width: 113,
          height: 38
        },
        url: ["ui" /* Ui */, "/accessory-tech/internet-solutions"]
      }, {
        id: "accessory-unifi-hosting-and-gateways",
        label: "CloudKeys & Gateways",
        icon: {
          src: _externalAssets_BM8zMoz6__default,
          width: 114,
          height: 25
        },
        url: ["ui" /* Ui */, "/accessory-tech/cloud-keys-gateways"]
      }]
    }, {
      id: NavigationItemId.UnifiIdentity,
      label: "Identity",
      url: ["ui" /* Ui */, "/identity"],
      // TODO: possible refactor type so we don't have to define empty items
      items: []
    }]
  },
  secondary: {
    label: "UISP",
    // NOTE: for initial launch don't go to uisp microsite instead to the first nested item, for now it's undefined
    fallbackUrl: ["uisp" /* Uisp */, "/"],
    items: [{
      id: NavigationItemId.UispSoftware,
      label: "UISP Overview",
      url: ["uisp" /* Uisp */, "/uisp-overview"],
      items: []
    }, {
      id: NavigationItemId.SixtyGhzWireless,
      label: "60 GHz Wireless",
      url: ["uisp" /* Uisp */, "/60ghz-wireless"],
      items: []
    }, {
      id: NavigationItemId.Wireless,
      label: "Wireless",
      // NOTE: for initial launch don't go to uisp microsite instead to the first nested item
      url: ["uisp" /* Uisp */, "/wireless"],
      items: [{
        id: "wiress-wave-mlo",
        label: "Wave MLO",
        subLabel: "5 & 6 GHz",
        subLabelCollapseMode: "horizontal",
        isNew: true,
        icon: {
          src: _externalAssets_DhQQZUho__default,
          width: 23,
          height: 31
        },
        url: ["uisp" /* Uisp */, "/wireless/wave-mlo"]
      }, {
        id: "ltu-5-ghz-wireless",
        label: "LTU",
        subLabel: "5 GHz",
        subLabelCollapseMode: "horizontal",
        icon: {
          src: _externalAssets_Dxp1T5JX__default,
          width: 41,
          height: 38
        },
        url: ["uisp" /* Uisp */, "/wireless/ltu"]
      }, {
        id: "airmax-5-ghz-wireless",
        label: "airMAX",
        subLabel: "5 GHz",
        subLabelCollapseMode: "horizontal",
        icon: {
          src: _externalAssets_LBBa85wh__default,
          width: 45,
          height: 38
        },
        url: ["uisp" /* Uisp */, "/wireless/airmax5ghz"]
      }, {
        id: "airmax-2-4-ghz-wireless",
        label: "airMAX",
        subLabel: "2.4 GHz",
        subLabelCollapseMode: "horizontal",
        icon: {
          src: _externalAssets_BOy2ygw4__default,
          width: 35,
          height: 38
        },
        url: ["uisp" /* Uisp */, "/wireless/airmax2-4ghz"]
      }, {
        id: "airfiber-ptp-wireless",
        label: "airFiber",
        subLabel: "PtP",
        subLabelCollapseMode: "horizontal",
        icon: {
          src: _externalAssets_CpudPnX7__default,
          width: 44,
          height: 38
        },
        url: ["uisp" /* Uisp */, "/wireless/airfiber"]
      }, {
        id: "antennas",
        label: "Antennas",
        icon: {
          src: _externalAssets_DnZUGHoA__default,
          width: 33,
          height: 38
        },
        url: ["uisp" /* Uisp */, "/wireless/antennas"]
      }]
    }, {
      id: NavigationItemId.Fiber,
      label: "Fiber",
      url: ["uisp" /* Uisp */, "/fiber"],
      items: [{
        id: "xgs-pon-fiber",
        label: "XGS-PON",
        icon: {
          src: _externalAssets_C6aD4TiH__default,
          width: 113,
          height: 20
        },
        url: ["uisp" /* Uisp */, "/fiber/xgs-pon"]
      }, {
        id: "gpon-fiber",
        label: "GPON",
        icon: {
          src: _externalAssets_IeLPrGjf__default,
          width: 113,
          height: 20
        },
        url: ["uisp" /* Uisp */, "/fiber/gpon"]
      }]
    }, {
      id: NavigationItemId.Wired,
      label: "Wired",
      // NOTE: for initial launch don't go to uisp microsite instead to the first nested item
      url: ["uisp" /* Uisp */, "/wired"],
      items: [{
        id: "wired-routing-switching",
        label: "UISP Routing / Switching",
        subLabel: "Simple",
        subLabelCollapseMode: "horizontal",
        icon: {
          src: _externalAssets_3p3EcO_W__default,
          width: 114,
          height: 23
        },
        url: ["uisp" /* Uisp */, "/wired/uisp-routing"]
      }, {
        id: "wired-advanced-routing-switching",
        label: "EdgeMAX Routing / Switching",
        subLabel: "Advanced",
        subLabelCollapseMode: "horizontal",
        icon: {
          src: _externalAssets_Dx2SMtBZ__default,
          width: 114,
          height: 31
        },
        url: ["uisp" /* Uisp */, "/wired/edgemax"],
        items: []
      }]
    }, {
      id: NavigationItemId.UispAccessoryTech,
      label: "Accessory Tech",
      url: ["techSpecs" /* TechSpecs */, "/uisp/accessory-tech"],
      // TODO: possible refactor type so we don't have to define empty items
      items: []
    }, {
      id: NavigationItemId.LargeDeploymentAssistance,
      label: "Large Deployment Assistance",
      url: ["expertsUisp" /* ExpertsUisp */, "/"],
      // TODO: possible refactor type so we don't have to define empty items
      items: []
    }]
  }
};
export { DEFAULT_LANGUAGE, DEFAULT_STORE_ID, GENERIC_SITE_IDS, LONG_LANGUAGES, Language, NAVIGATION_MAPPING, NavigationItemId, SiteId };
//# sourceMappingURL=mapping.mjs.map
